// src/app/meter/components/meter-analytics/meter-kpi-cards/meter-kpi-cards.component.ts

import { Component, Input } from '@angular/core';
import { MeterSnapshotResponse } from '../../../models/meter-analytics.model';

@Component({
    selector: 'app-meter-kpi-cards',
    templateUrl: './meter-kpi-cards.component.html',
    styleUrls: ['./meter-kpi-cards.component.scss'],
})
export class MeterKpiCardsComponent {
    @Input() snapshot: MeterSnapshotResponse;
    @Input() comparePrevious = false;

    getDelta(current: number, previous: number | undefined): number | null {
        if (!this.comparePrevious || previous === undefined) {
            return null;
        }
        return +(current - previous).toFixed(1);
    }

    getPercentDelta(current: number, previous: number | undefined): number | null {
        if (!this.comparePrevious || previous === undefined || previous === 0) {
            return null;
        }
        return +(((current - previous) / previous) * 100).toFixed(1);
    }
}
